export default {
  name: "Login",
};